import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@environments/environment';
import { optionsSports } from '../';

@Component({
  selector: 'app-pre-render-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pre-render-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderFooterComponent {
  urlIMG = environment.urlIMG;
  urlIcon = environment.urlIcon;

  optionsSports = optionsSports;
}
